import React from 'react';
import { Clock, ShoppingCart, Utensils, BookOpen, Coffee } from 'lucide-react';
export const Bonuses: React.FC = () => {
  const bonuses = [{
    id: 1,
    title: 'Guía SOS: Manual de la Última Hora',
    desc: 'Alivio en 5 minutos.',
    icon: <Clock size={24} className="text-sage" data-id="element-29" />,
    value: '$5.000'
  }, {
    id: 2,
    title: 'Semáforo del Súper Argentino',
    desc: 'Lista de compras lista para usar.',
    icon: <ShoppingCart size={24} className="text-sage" data-id="element-30" />,
    value: '$4.500'
  }, {
    id: 3,
    title: 'Recetario: Cenas de 15 Min',
    desc: 'Que no arden.',
    icon: <Utensils size={24} className="text-sage" data-id="element-31" />,
    value: '$6.000'
  }, {
    id: 4,
    title: 'Diario Detective de Disparadores',
    desc: 'Estrategia personalizada.',
    icon: <BookOpen size={24} className="text-sage" data-id="element-32" />,
    value: '$4.500'
  }, {
    id: 5,
    title: 'Manual del Mate Seguro',
    desc: 'Cómo tomar sin pagar el precio.',
    icon: <Coffee size={24} className="text-sage" data-id="element-33" />,
    value: '$5.000'
  }];
  return <section className="py-16 md:py-24 px-4 bg-cream-card" data-id="element-34">
      <div className="max-w-6xl mx-auto" data-id="element-35">
        <h2 className="font-serif text-3xl md:text-4xl text-earth font-bold mb-12 text-center max-w-2xl mx-auto" data-id="element-36">
          Si accedés HOY, te llevás estos 5 Bonus VIP de regalo:
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12" data-id="element-37">
          {bonuses.map((bonus, index) => <div key={bonus.id} className={`bg-white rounded-2xl p-6 shadow-sm border border-terracotta/10 relative overflow-hidden flex flex-col h-full ${index === 4 ? 'md:col-span-2 lg:col-span-1 md:max-w-md md:mx-auto lg:max-w-none lg:mx-0 w-full' : ''}`} data-id="element-38">
              <div className="absolute top-0 right-0 bg-terracotta text-white text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-39">
                BONUS {bonus.id}
              </div>

              <div className="w-12 h-12 bg-sage/10 rounded-xl flex items-center justify-center mb-4" data-id="element-40">
                {bonus.icon}
              </div>

              <h3 className="font-sans font-bold text-earth text-lg mb-2 pr-12" data-id="element-41">
                {bonus.title}
              </h3>

              <p className="font-sans text-earth-light text-sm mb-6 flex-grow" data-id="element-42">
                {bonus.desc}
              </p>

              <div className="mt-auto pt-4 border-t border-cream-card flex justify-between items-center" data-id="element-43">
                <span className="text-xs text-earth-light uppercase tracking-wider" data-id="element-44">
                  Valor Normal
                </span>
                <span className="font-mono text-terracotta/60 line-through text-sm" data-id="element-45">
                  {bonus.value}
                </span>
              </div>
            </div>)}
        </div>

        <div className="text-center bg-white rounded-xl py-6 px-4 border-2 border-terracotta/20 max-w-2xl mx-auto shadow-sm" data-id="element-46">
          <p className="font-sans text-lg md:text-xl text-earth" data-id="element-47">
            <span className="font-bold" data-id="element-48">
              Valor total de los bonus:{' '}
              <span className="line-through opacity-70" data-id="element-49">$25.000</span>
            </span>
            <span className="block md:inline md:ml-2 text-terracotta font-bold mt-2 md:mt-0" data-id="element-50">
              → Gratis con tu compra de hoy.
            </span>
          </p>
        </div>
      </div>
    </section>;
};